module.exports = __webpack_public_path__ + "static/media/element_dots_square.cb531046.svg";